import { render } from "./pharmacy-search.vue?vue&type=template&id=3b82e6e6"
import script from "./pharmacy-search.vue?vue&type=script&lang=js"
export * from "./pharmacy-search.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__